// extracted by mini-css-extract-plugin
export default {"checkbox_container":"style_checkbox_container__OvWLT"};